type Props = {};

export const CreateEventIcon = (props: Props) => {
  return (
    <svg fill="none" height="56" viewBox="0 0 57 56" width="57" xmlns="http://www.w3.org/2000/svg">
      <rect fill="#D4E4FF" height="56" rx="28" width="56" x="0.666504" />
      <mask
        height="32"
        id="mask0_6484_3395"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="33"
        x="12"
        y="12"
      >
        <rect fill="#D9D9D9" height="32" width="32" x="12.6665" y="12" />
      </mask>
      <g mask="url(#mask0_6484_3395)">
        <path
          d="M28.6663 30.6664L25.9996 27.9998L28.6663 25.3331L31.3329 27.9998L28.6663 30.6664ZM25.8329 22.8331L22.4996 19.4998L26.7663 15.2331C27.0329 14.9664 27.3329 14.7664 27.6663 14.6331C27.9996 14.4998 28.3329 14.4331 28.6663 14.4331C28.9996 14.4331 29.3329 14.4998 29.6663 14.6331C29.9996 14.7664 30.2996 14.9664 30.5663 15.2331L34.8329 19.4998L31.4996 22.8331L28.6663 19.9998L25.8329 22.8331ZM20.1663 34.1664L15.8996 29.8998C15.6329 29.6331 15.4329 29.3331 15.2996 28.9998C15.1663 28.6664 15.0996 28.3331 15.0996 27.9998C15.0996 27.6664 15.1663 27.3331 15.2996 26.9998C15.4329 26.6664 15.6329 26.3664 15.8996 26.0998L20.1663 21.8331L23.4996 25.1664L20.6663 27.9998L23.4996 30.8331L20.1663 34.1664ZM37.1663 34.1664L33.8329 30.8331L36.6663 27.9998L33.8329 25.1664L37.1663 21.8331L41.4329 26.0998C41.6996 26.3664 41.8996 26.6664 42.0329 26.9998C42.1663 27.3331 42.2329 27.6664 42.2329 27.9998C42.2329 28.3331 42.1663 28.6664 42.0329 28.9998C41.8996 29.3331 41.6996 29.6331 41.4329 29.8998L37.1663 34.1664ZM26.7663 40.7664L22.4996 36.4998L25.8329 33.1664L28.6663 35.9998L31.4996 33.1664L34.8329 36.4998L30.5663 40.7664C30.2996 41.0331 29.9996 41.2331 29.6663 41.3664C29.3329 41.4998 28.9996 41.5664 28.6663 41.5664C28.3329 41.5664 27.9996 41.4998 27.6663 41.3664C27.3329 41.2331 27.0329 41.0331 26.7663 40.7664Z"
          fill="#0056B8"
        />
      </g>
    </svg>
  );
};
